<template>
    <div class="onboarding">

        <Navbar></Navbar>

        <div class="container">
            <!-- naming: onboarding_second_screen = oss  -->
            <div class="oss-wrapp">
                <div class="oss-wrapp_right">
                    <img class="" src="~@/assets/img/sample/oss-detail.png" />
                </div>

                <div class="oss-wrapp_left">
                    <div class="oss-wrapp_left__intro">
                        <h3>
                            <span>Pridruži se Toni Milun Ligi</span>
                            i ne propusti priliku da osvojiš super nagrade!
                        </h3>

                        <p>
                            Za sudjelovanje u Ligi potrebno je registrirati se.
                            Kada se registriraš osim što ćeš moći sudjelovati u Ligi imaš mogućnost osvajanja i drugih nagrada.
                        </p>
                    </div>

                    <div class="questions-wrapp">
                        <div class="questions-wrapp_info">
                            <h3>
                                Što je liga i kako se igra ?
                            </h3>
                            <p>
                                Liga ima 10 pitanja iz 4 područja.
                                Broj pitanja po predmetu je ograničen i to na sljedeći način
                            </p>
                            <ul>
                                <li>
                                    3 pitanja iz <span>matematike</span>
                                </li>
                                <li>
                                    3 pitanja iz <span>popularne znanosti</span>
                                </li>
                                <li>
                                    2 pitanja iz <span>digitalnog društva</span>
                                </li>
                                <li>
                                    2 pitanja iz <span>engleskog jezika</span>
                                </li>
                            </ul>
                        </div>
                        <div class="questions-wrapp_points">
                            <h3>
                                Svako točno odgovoreno pitanje nosi određen broj bodova. Osim točnosti nagrađujemo i brzinu,tako da što prije odabereš odgovor na pitanje skupit ćeš više bodova!
                            </h3>

                            <div class="customTable">
                                <ul>
                                    <li>
                                        <p class="title subject">Predmet</p>
                                        <p class="title points">Bodovi</p>
                                    </li>
                                    <li>
                                        <p class="subject">matematika</p>
                                        <p class="points">500</p>
                                    </li>
                                    <li>
                                        <p class="subject">popularna znanost</p>
                                        <p class="points">400</p>
                                    </li>
                                    <li>
                                        <p class="subject">digitalno društvo</p>
                                        <p class="points">300</p>
                                    </li>
                                    <li>
                                        <p class="subject">engleski jezik</p>
                                        <p class="points">200</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="video-section">
                    <!-- TODO: not needed anymore as video has changed -->
                    <!-- <h3>
                        Za tebe smo pripremili i video o tome kako se igra liga
                    </h3> -->
                    <div class="video-wrapp">
                        <iframe src="https://player.vimeo.com/video/378984307" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                    </div>
                </div>
                <router-link to="/probno-pitanje/1" href="#" @click.prevent="goBack" class="button-1 red no-arrow testni"><span>Pokreni testni kviz</span></router-link>
            </div>
        </div>

    </div>
</template>

<script>
import Navbar from '../components/Navbar'

export default {
    name: 'onboardingguide',
    methods: {
    },
    components: {
        Navbar
    }
}
</script>

<style scoped lang="scss">
    .testni {
        margin-top: 35px;
        margin-bottom: 35px;
    }
    .oss-wrapp {
        position: relative;
        width: 100%;
        overflow: hidden;
        max-width: 1500px;
        margin: 0 auto;
        .oss-wrapp_right {
            width: 100%;
            position: relative;
            margin-bottom: 30px;
            img {
                max-width: 865px;
                width: 100%;
                height: auto;
            }
        }
        .oss-wrapp_left {
            width: 100%;
            position: relative;
            .oss-wrapp_left__intro {
                margin-bottom: 40px;
                text-align: left;
                max-width: 540px;
                h3 {
                    font-family: $font-mPlus;
                    font-size: 22px;
                    font-weight: bold;
                    margin-bottom: 30px;
                    color: #000;
                    span {
                        color: #ff0026;
                    }
                }
                p{
                    font-family: $font-mPlus;
                    font-size: 16px;
                    font-weight: bold;
                    color: #000;
                    line-height: 1.5em;
                }
            }
            .questions-wrapp {
                margin-bottom: 120px;
                max-width: 540px;
                .questions-wrapp_info {
                    text-align: left;
                    h3 {
                        color: #000;
                        font-size: 16px;
                        font-family: $font-mPlus;
                        margin-bottom: 20px;
                    }
                    p {
                        font-size: 14px;
                        line-height: 1.5em;
                        font-family: $font-axiforma;
                        color: #555d63;
                        font-weight: bold;
                    }
                    ul {
                        list-style-type: disc;
                        padding-left: 15px;
                        margin-bottom: 35px;
                        li {
                            font-size: 14px;
                            font-family: $font-axiforma;
                            color: #555d63;
                            margin-bottom: 10px;
                            font-weight: bold;
                            line-height: 1.5em;
                            span {
                                text-transform: uppercase;
                            }
                        }
                    }
                }
                .questions-wrapp_points {
                    text-align: left;
                    h3 {
                        font-size: 14px;
                        line-height: 1.5em;
                        font-family: $font-axiforma;
                        color: #000;
                        font-weight: bold;
                    }
                    .customTable {
                        margin-top: 50px;
                        background: #fff;
                        border-radius: 10px;
                        box-shadow: 0px 57px 40px -60px rgba(0, 0, 0, 0.45);
                        ul {
                            position: relative;
                            width: 100%;
                            padding: 10px 20px;
                            li {
                                width: 100%;
                                position: relative;
                                overflow: hidden;
                                padding: 10px 0px;
                                border-bottom: 1px solid #dbdbdb;
                                &:last-child {
                                    border-bottom: none;
                                }
                                .title {
                                    float: left;
                                    font-family: $font-mPlus;
                                    color: #000;
                                    font-size: 16px;
                                    font-weight: bold;
                                    &.subject {
                                        width: 70%;
                                        padding-right: 20px;
                                    }
                                    &.points {
                                        width: 30%;
                                    }
                                }
                                p {
                                    font-size: 14px;
                                    font-family: $font-axiforma;
                                    color: #555d63;
                                    float: left;
                                    margin-bottom: 0;
                                    line-height: 1.5em;
                                    &.subject {
                                        width: 70%;
                                        padding-right: 20px;
                                    }
                                    &.points {
                                        width: 30%;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        .video-section {
            text-align: left;
            position: relative;
            width: 100%;
            overflow: hidden;
            margin-bottom: 50px;
            h3 {
                font-size: 22px;
                line-height: 1.2em;
                color: #000;
                font-family: $font-mPlus;
                margin-bottom: 40px;
                font-weight: bold;
                max-width: 540px;
            }
            .video-wrapp {
                position: relative;
                padding-bottom: 56.666667%;
                max-width: 100%;
                height: auto;
                iframe, object, embed {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                }
            }
        }
        @media only screen and (min-width: 800px) {
            .oss-wrapp_left, .oss-wrapp_right {
                float: right;
                width: 50%;
            }
            .oss-wrapp_left__intro, .video-section {
                h3 {
                    font-size: 28px;
                }
            }
            .oss-wrapp_left .questions-wrapp {
                margin-bottom: 60px;
            }
            .video-section {
                margin-bottom: 0;
            }
        }
    }
</style>
